module.exports = {
  vistasData: () => {
    return {
      "pisos": [
        {
          "name": "Piso 6",
          "thumb": require("./../assets/images/vistas/piso 6/vista aptos 604 y 603.webp"),
          "galleries": [
            {
              "name": "Vista apartamento 605",
              "image": require("./../assets/images/vistas/piso 6/vista apto 605.webp")
            },
            {
              "name": "Vista apartamento 606",
              "image": require("./../assets/images/vistas/piso 6/vista apto 606.webp")
            },
            {
              "name": "Vista apartamentos 604 y 603",
              "image": require("./../assets/images/vistas/piso 6/vista aptos 604 y 603.webp")
            },
          ]
        },
        {
          "name": "Piso 8",
          "thumb": require("./../assets/images/vistas/piso 8/vista apto 803.webp"),
          "galleries": [
            {
              "name": "Vista apartamento 803",
              "image": require("./../assets/images/vistas/piso 8/vista apto 803.webp")
            },
            {
              "name": "Vista apartamento 804",
              "image": require("./../assets/images/vistas/piso 8/vista apto 804.webp")
            },
            {
              "name": "Vista apartamento 805",
              "image": require("./../assets/images/vistas/piso 8/vista apto 805.webp")
            },
            {
              "name": "Vista apartamento 806",
              "image": require("./../assets/images/vistas/piso 8/vista apto 806.webp")
            },
          ]
        },
        {
          "name": "Piso 10",
          "thumb": require("./../assets/images/vistas/piso 10/vista piso 10.webp"),
          "galleries": [
            {
              "name": "Vista piso 10",
              "image": require("./../assets/images/vistas/piso 10/vista piso 10.webp")
            }
          ]
        },
        {
          "name": "Piso 12",
          "thumb": require("./../assets/images/vistas/piso 12/vista apto 1203.webp"),
          "galleries": [
            {
              "name": "Vista apartamento 1203",
              "image": require("./../assets/images/vistas/piso 12/vista apto 1203.webp")
            },
            {
              "name": "Vista apartamento 1204",
              "image": require("./../assets/images/vistas/piso 12/vista apto 1204.webp")
            },
            {
              "name": "Vista apartamento 1205",
              "image": require("./../assets/images/vistas/piso 12/vista apto 1205.webp")
            },
            {
              "name": "Vista apartamento 1206",
              "image": require("./../assets/images/vistas/piso 12/vista apto 1206.webp")
            },
          ]
        },
        {
          "name": "Piso 16",
          "thumb": require("./../assets/images/vistas/piso 16/vista apto 1603.webp"),
          "galleries": [
            {
              "name": "Vista apartamento 1603",
              "image": require("./../assets/images/vistas/piso 16/vista apto 1603.webp")
            },
            {
              "name": "Vista apartamento 1604",
              "image": require("./../assets/images/vistas/piso 16/vista apto 1604.webp")
            },
            {
              "name": "Vista apartamento 1605",
              "image": require("./../assets/images/vistas/piso 16/vista apto 1605.webp")
            },
            {
              "name": "Vista apartamento 1606",
              "image": require("./../assets/images/vistas/piso 16/vista apto 1606.webp")
            },
          ]
        },
        {
          "name": "Piso 18",
          "thumb": require("./../assets/images/vistas/piso 18/Vista piso 18.webp"),
          "galleries": [
            {
              "name": "Vista piso 18",
              "image": require("./../assets/images/vistas/piso 18/Vista piso 18.webp")
            }
          ]
        },
      ]
    }
  }
}